import { useContext } from "react";
import { POSContext } from "../context/POSContext";

export const usePOSService = () => {
  const context = useContext(POSContext);

  if (!context) {
    throw new Error("usePOSService must be used within a POSProvider");
  }

  return {
    posService: context.posService,
    sessionId: context.sessionId,
    isSessionActive: context.isSessionActive,
    sessionData: context.sessionData,
    isLoading: context.isLoading,
    startSession: context.startSession,
    endSession: context.endSession,
    checkSession: context.checkSession,
    error: context.error,
    clearError: context.clearError,
  };
};
